<template>
  <v-layout
    row
    justify-center
  >
    <v-dialog
      v-model="dialog"
      max-width="600"
      @input="v => v || closeDialog()"
    >
      <v-card>
        <v-card-title class="card-title">
          <span class="headline white--text text-uppercase">Create Draft</span>
        </v-card-title>

        <v-card-text>
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
          >
            <v-container fluid>
              <v-alert
                v-if="instrument === 'bond-priip'"
                :value="true"
                type="warning"
              >
                Yield Projects can now automatically be created via Magic Tool.
              </v-alert>
              <v-layout
                row
                wrap
              >
                <v-flex
                  xs12
                  sm6
                >
                  <v-select
                    v-model="instrument"
                    :items="instruments"
                    item-text="name"
                    item-value="value"
                    :rules="requiredRule"
                    label="Instrument"
                  />
                </v-flex>

                <v-flex
                  xs12
                  sm6
                >
                  <v-text-field
                    v-model="project_name"
                    type="text"
                    label="Project Name"
                    :rules="requiredRule"
                    required
                  />
                </v-flex>

                <v-flex
                  xs12
                  sm6
                >
                  <v-select
                    v-model="securityIdType"
                    :items="securityIdTypes"
                    item-value="value"
                    label="Security Id Type"
                    item-text="name"
                    :rules="requiredRule"
                  />
                </v-flex>

                <v-flex
                  xs12
                  sm6
                >
                  <v-text-field
                    v-model="securityId"
                    type="text"
                    label="Security Id"
                    :rules="requiredRule"
                    required
                  />
                </v-flex>

                <v-flex
                  xs12
                  sm6
                >
                  <v-select
                    v-model="regulationType"
                    :items="regulationTypes"
                    item-value="value"
                    label="Regulation Type"
                    item-text="name"
                    :rules="requiredRule"
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>

          <v-alert
            v-if="error"
            :value="true"
            type="error"
            class="my-3"
          >
            {{ error }}
          </v-alert>
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn
            color="blue darken-1"
            flat="flat"
            :disabled="processing"
            @click="closeDialog"
          >
            cancel
          </v-btn>

          <v-btn
            color="blue darken-1"
            flat="flat"
            :disabled="processing"
            @click="createDraft"
          >
            create
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>

import { DeprecatedFinancialInstruments, FinancialInstrumentsEnum } from '@/enum/financialProducts/FinancialInstruments';
import SecurityIdTypesEnum from '../../enum/financialProducts/SecurityIdTypes';
import RegulationTypeEnum from '../../enum/financialProducts/RegulationType';
import OwnerIdsEnum from '../../enum/financialProducts/OwnerIds';

export default {
  name: 'CreateDraft',
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: '',
    },
    processing: {
      type: Boolean,
      default: false,
    },
    submitAction: {
      type: Function,
      default: () => ({}),
    },
    cancelAction: {
      type: Function,
      default: () => ({}),
    },
  },
  data() {
    return {
      valid: true,
      instrument: null,
      project_name: null,
      ownerId: null,
      securityIdType: null,
      regulationType: null,
      securityId: null,
      requiredRule: [
        v => !!v || 'field is required',
      ],
    };
  },
  computed: {
    instruments() {
      return Object.keys(FinancialInstrumentsEnum)
        .map(key => FinancialInstrumentsEnum[key])
        .filter(value => !DeprecatedFinancialInstruments.includes(value));
    },
    securityIdTypes() {
      return Object.keys(SecurityIdTypesEnum).map(key => ({
        name: SecurityIdTypesEnum[key],
        value: SecurityIdTypesEnum[key],
      }));
    },
    regulationTypes() {
      return Object.keys(RegulationTypeEnum).map(key => ({
        name: RegulationTypeEnum[key],
        value: RegulationTypeEnum[key],
      }));
    },
  },
  watch: {
    data(val) {
      this.instrument = val.instrument;
      this.project_name = val.project_name;
      this.ownerId = val.ownerId;
      this.securityIdType = val.securityIdType;
      this.securityId = val.securityId;
      this.regulationType = val.regulationType;
    },
  },
  methods: {
    async createDraft() {
      if (this.$refs.form.validate()) {
        this.submitAction({
          instrument: this.instrument,
          project_name: this.project_name,
          owner_id: OwnerIdsEnum.exporo,
          security_id_type: this.securityIdType,
          security_id: this.securityId,
          regulationType: this.regulationType,
        });
      }
    },
    closeDialog() {
      this.cancelAction();
    },
  },
};
</script>

<style lang="scss" scoped>
  .saldo-info {
    width: 90%;
    margin: 5px auto auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/financialProducts/CreateDraft.vue